import { queryOptions } from "@tanstack/react-query";

import type { BookmarkWithCase } from "@kansai-ai-hub/api-client";

import { fetchAllPaginated } from "@/lib/fetch-all-pages";

export const bookmarkKeys = {
  all: ["bookmarks"] as const,
  mineAll: () => [...bookmarkKeys.all, "mine-all"] as const,
} as const;

/**
 * 自分の保存済み案件を**全件**取得する（ページ上限に縛られない）。
 * - 案件一覧/企業詳細の「保存済み」バッジ判定（保存済み案件 ID 集合）
 * - 保存済みページ（企業別グルーピング）
 * のいずれもこの 1 クエリを共有し、保存トグルはこのキーを invalidate する。
 * サーバは role(MEMBER) で「自分の保存」を判定するため追加パラメータは送らない。
 */
export function allMyBookmarksQueryOptions() {
  return queryOptions({
    queryKey: bookmarkKeys.mineAll(),
    queryFn: () => fetchAllPaginated<BookmarkWithCase>("/api/v1/bookmarks"),
    staleTime: 30_000,
  });
}
